export const colors = {
  7: "#FF5733", // Color for usernames with 7 letters
  8: "#33FF57", // Color for usernames with 8 letters
  9: "#5733FF", // Color for usernames with 9 letters
  10: "#3357FF", // Color for usernames with 10 letters
  11: "#FF33A1", // Color for usernames with 11 letters
  12: "#A133FF", // Color for usernames with 12 letters
  13: "#FF33FF", // Color for usernames with 13 letters
  14: "#33FFA1", // Color for usernames with 14 letters
  15: "#FFA133", // Color for usernames with 15 letters
  16: "#FF5733", // Color for usernames with 16 letters
  17: "#33FF33", // Color for usernames with 17 letters
  18: "#5733FF", // Color for usernames with 18 letters
  19: "#3357FF", // Color for usernames with 19 letters
  20: "#A133FF", // Color for usernames with 20 letters
  21: "#3333FF", // Color for usernames with more than 20 letters
};

export const exclusionKeys = new Set(["rowIndex", "#", "id", "l_id"]);

export const LEVEL_OPTIONS = [
  { label: "All Levels", value: "all" },
  { label: "Level 1", value: "level_1" },
  { label: "Level 2", value: "level_2" },
  { label: "Level 3", value: "level_3" },
];

export const ignoreHeaderNames = new Set([
  "Current Weeks",
  "Current Week",
  "Previous Weeks",
  "Next Weeks",
  "Current Month",
  "Current Months",
  "Previous Months",
  "Next Months"
]);